// extracted by mini-css-extract-plugin
module.exports = {"root":"Chip_root__2kGRn","selected":"Chip_selected__mD6yv"};